export const DriversHandbooksRels = {
    getDriversHandbooks: 'getDriversHandbooks',
    getDriversHandbook: 'getDriversHandbook',
    createDriversHandbook: 'createDriversHandbook',
    updateDriversHandbook: 'updateDriversHandbook',
    deleteDriversHandbook: 'deleteDriversHandbook'
};
